import * as React from 'react';
import type { SVGProps } from 'react';
const WriteEmailIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M9.264 7.693h1.518a.627.627 0 0 0 .446-.182L14.1 4.637a.628.628 0 0 0 0-.891l-1.518-1.518a.628.628 0 0 0-.89 0L8.817 5.1a.659.659 0 0 0-.182.446v1.518a.627.627 0 0 0 .628.628ZM9.89 5.81l2.246-2.246.628.628-2.246 2.246H9.89V5.81Zm3.765 1.255a.627.627 0 0 0-.628.628v4.392a.627.627 0 0 1-.627.627H3.617a.627.627 0 0 1-.628-.627v-6.03l3.69 3.696a1.883 1.883 0 0 0 2.679 0 .627.627 0 1 0-.897-.879.627.627 0 0 1-.879 0L3.874 5.17h2.88a.628.628 0 0 0 0-1.255H3.617a1.882 1.882 0 0 0-1.883 1.883v6.274a1.882 1.882 0 0 0 1.883 1.883H12.4a1.882 1.882 0 0 0 1.882-1.883V7.68a.628.628 0 0 0-.627-.627v.012Z"
    />
  </svg>
);
export default WriteEmailIcon;
